/*
 * Copyright (c) 2022, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */
import React from 'react';
import {useStyles} from './style';

interface PenEditIconProps {
    isInteractive: boolean;
}

export default function PenEditIcon(props: PenEditIconProps) {
    const classes = useStyles();
    const {isInteractive} = props;

    return (
        <svg
            width="14"
            height="14"
            viewBox="0 0 15 15"
            className={isInteractive ? classes.interactiveIcon : classes.defaultIcon}
        >
            <path
                id="Combined_Shape"
                d="M0,7A7,7,0,0,1,7,0,.5.5,0,0,1,7,1a6,6,0,1,0,6,6,.5.5,0,1,1,1,0A7,7,0,0,1,0,7ZM5.623,
        8.909v0l.716-3.54L10.765.556A1.872,1.872,0,0,1,13.413.541a1.962,1.962,0,0,1,.06,2.74L9.038,
        8.069l-3.414.84Zm5.859-7.656L7.245,5.86l-.47,1.8L8.5,7.182,12.74,2.6a.965.965,0,0,0,
        .05-1.26l-.079-.089A.874.874,0,0,0,12.093,1,.849.849,0,0,0,11.482,1.253Z"
                transform="translate(1 1)"
            />
        </svg>
    );
}
